/**
 * Compare JavaScript
 *
 * This file defines behaviors of
 * the Compare component.
 */

document.querySelectorAll('.compare')?.forEach((compare) => {
	const input = compare.querySelector('.compare__input');
	input.addEventListener('input', (e) => {
		compare.style.setProperty('--compare', `${e.target.value}%`);
	});
});
